import { useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { FaPlay, FaPause, FaExpand, FaCompress, FaXmark } from "react-icons/fa6";

function VideoPlayer({ camera, onClose }) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);

  if (!camera) return null;

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  console.log("camera", camera);

  return (
    <Box sx={{
      position: isFullScreen ? 'fixed' : 'relative',
      top: isFullScreen ? 0 : 'auto', left: isFullScreen ? 0 : 'auto',
      width: '100%', height: '100%',
      bgcolor: 'black',
      zIndex: isFullScreen ? 1300 : 'auto',
      display: isFullScreen ? 'flex' : 'block',
      alignItems: 'center', justifyContent: 'center',
      borderRadius: isFullScreen ? 0 : '16px',
      overflow: 'hidden',
      '&:hover .video-controls': { opacity: 1 }
    }}>

      {/* Close Button */}
      {!isFullScreen && (
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute', top: 16, right: 16, zIndex: 20,
            bgcolor: 'rgba(0,0,0,0.4)', color: 'white',
            '&:hover': { bgcolor: 'rgba(0,0,0,0.6)' }
          }}
          title="Close Player"
        >
          <FaXmark size={20} />
        </IconButton>
      )}

      <Box
        component="img"
        src={camera.thumbnail?.replace("w=600", "w=1200")}
        alt={camera.title}
        sx={{
          width: '100%', height: '100%',
          objectFit: isFullScreen ? 'contain' : 'cover',
          opacity: 0.9, transition: 'opacity 0.3s',
          '&:hover': { opacity: 1 }
        }}
      />

      <Box
        className="video-controls"
        sx={{
          position: 'absolute', bottom: 0,
          left: 0, right: 0, // UPDATED: width: 100% മാറ്റി left/right 0 കൊടുത്തു
          background: 'linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0.4), transparent)',
          p: { xs: 2, md: 3 },
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-end',
          transition: 'opacity 0.3s',
          opacity: isFullScreen ? 0 : 1
        }}
      >

        {isFullScreen && (
          <Typography sx={{ position: 'absolute', top: 24, left: 24, color: 'white', fontSize: '20px', fontWeight: 'bold' }}>
            {camera.title}
          </Typography>
        )}

        {/* Progress Bar */}
        <Box sx={{
          width: '100%', height: '4px', bgcolor: 'rgba(75,85,99,0.5)',
          borderRadius: '99px', mb: 2, position: 'relative', cursor: 'pointer',
          '&:hover .scrubber': { opacity: 1 }
        }}>
          <Box sx={{ width: '40%', height: '100%', bgcolor: '#FFCC33', borderRadius: '99px', position: 'relative' }}>
            <Box className="scrubber" sx={{
              position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)',
              width: '12px', height: '12px', bgcolor: '#FFCC33', borderRadius: '50%', opacity: 0, transition: '0.2s'
            }} />
          </Box>
        </Box>

        {/* Control Buttons */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: 'white' }}>

          <Box sx={{ display: 'flex', gap: 2 }}>
            <IconButton onClick={() => setIsPlaying(!isPlaying)} sx={{ color: 'white', '&:hover': { color: '#FFCC33' } }}>
              {isPlaying ? <FaPause size={20} /> : <FaPlay size={20} />}
            </IconButton>
          </Box>

          <Box>
            <IconButton onClick={toggleFullScreen} sx={{ color: 'white', '&:hover': { color: '#FFCC33' } }}>
              {isFullScreen ? <FaCompress size={20} /> : <FaExpand size={20} />}
            </IconButton>
          </Box>

        </Box>
      </Box>
    </Box>
  );
}

export default VideoPlayer;